import { render, staticRenderFns } from "./Ecl.vue?vue&type=template&id=2889da82&"
import script from "./Ecl.vue?vue&type=script&lang=js&"
export * from "./Ecl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports